import {HttpService} from "./HttpService";
import {AxiosResponse} from "axios";
import Article, {ArticleType} from "./model/Article";

export default class ArticleApi {
    public static async search(params: IArticleSearchParams): Promise<ISearchResponse<Article>> {
        const response: AxiosResponse<ISearchResponse<Article>> = await HttpService.get('/article/search', {
            params: params
        });
        return response.data;
    }

    public static async queryById(params: IArticleQueryByIdParams): Promise<Article> {
        const response: AxiosResponse<Article> = await HttpService.get('/article/queryById', {
            params: params
        });
        return new Article(response.data);
    }
}

interface ISearchResponse<T> {
    totalCount: number;
    list: T[]
}

interface IArticleSearchParams {
    pi: number;
    ps: number;
    type: ArticleType;
}

interface IArticleQueryByIdParams {
    id: number;
}